module.exports = __webpack_public_path__ + "img/run2.2373c06b.png";